import React from "react";
import PropTypes from "prop-types";
import { languages, languageMap } from "../constants/languages.constants";
import { MenuItem, Select } from "material-ui";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    select: {
        marginTop: 2,
        marginLeft: 4 * theme.spacing.unit,
        color: "white",
        border: 0
    },
    link: {
        textDecoration: "none",
        color: theme.palette.text.primary
    },
    icon: {
        fill: "white"
    }
});

function getLink(language) {
    let h = window.location.hostname;
    let split = h.split(".");
    if (split.length > 1) {
        let newHostname = split.slice(1);
        newHostname.unshift(language);
        return "//" + newHostname.join(".");
    }
    let url = "//" + window.location.hostname;
    if (window.location.port) {
        url += ":" + window.location.port;
    }
    url += "?lng=" + language;
    return url;
}

const AppLanguageSelect = props => {
    const { i18n, classes } = props;

    const onChange = event => {
        window.location.href = getLink(event.target.value);
    };

    return (
        <Select
            disableUnderline={true}
            classes={{ icon: classes.icon }}
            onChange={onChange}
            className={classes.select}
            value={i18n.language}
            renderValue={value => languageMap[value].nativeText}>
            {languages.map(language => {
                return (
                    <MenuItem key={language.value} value={language.value}>
                        <a
                            href={getLink(language.value)}
                            className={classes.link}>
                            {language.nativeText}
                        </a>
                    </MenuItem>
                );
            })}
        </Select>
    );
};

AppLanguageSelect.propTypes = {
    t: PropTypes.func.isRequired,
    i18n: PropTypes.object.isRequired,
    classes: PropTypes.object
};

export default withStylesAndTranslation(AppLanguageSelect, styleSheet);



// WEBPACK FOOTER //
// ./src/components/AppLanguageSelect.jsx